import { EditableTitle, DragHandle } from '../shared/components';
import { Button, Tooltip } from '@bancobarigui/barihaus';
import { EditOutlined, CopyOutlined, DeleteOutlined, RightOutlined, DownOutlined } from '@ant-design/icons';
import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd';

interface SectionHeaderProps {
  name: string;
  isEditing: boolean;
  editValue: string;
  onEditValueChange: (value: string) => void;
  onSave: () => void;
  onCancel: () => void;
  onEdit: () => void;
  onDuplicate: () => void;
  onRemove: () => void;
  isCollapsed: boolean;
  onToggleCollapse: () => void;
  dragHandleProps: DraggableProvidedDragHandleProps | null;
}

export function SectionHeader({
  name,
  isEditing,
  editValue,
  onEditValueChange,
  onSave,
  onCancel,
  onEdit,
  onDuplicate,
  onRemove,
  isCollapsed,
  onToggleCollapse,
  dragHandleProps,
}: SectionHeaderProps) {
  const handleHeaderClick = (e: React.MouseEvent) => {
    if (isEditing) return;

    const target = e.target as HTMLElement;
    if (target.closest('button')) return;

    onToggleCollapse();
  };

  return (
    <div
      className={`flex items-center justify-between cursor-pointer ${!isCollapsed ? 'mb-3' : ''}`}
      onClick={handleHeaderClick}
    >
      <div className="flex items-center gap-2 flex-1">
        <DragHandle dragHandleProps={dragHandleProps} size="medium" />

        {isEditing ? (
          <EditableTitle
            value={editValue}
            onChange={onEditValueChange}
            onSave={onSave}
            onCancel={onCancel}
            size="small"
            placeholder="Nome da seção"
          />
        ) : (
          <>
            <h4 className="text-base font-medium text-gray-700 m-0">
              {name}
            </h4>
            <div className="flex items-center" onClick={(e) => e.stopPropagation()}>
              <Tooltip title="Editar nome da seção">
                <Button
                  type="text"
                  size="small"
                  icon={<EditOutlined />}
                  onClick={onEdit}
                  children={undefined}
                />
              </Tooltip>
              <Tooltip title="Duplicar seção">
                <Button
                  type="text"
                  size="small"
                  icon={<CopyOutlined />}
                  onClick={onDuplicate}
                  children={undefined}
                />
              </Tooltip>
              <Tooltip title="Remover seção">
                <Button
                  type="text"
                  size="small"
                  danger
                  icon={<DeleteOutlined />}
                  onClick={onRemove}
                  children={undefined}
                />
              </Tooltip>
            </div>
          </>
        )}
      </div>

      {!isEditing && (
        <Button
          type="text"
          size="small"
          icon={isCollapsed ? <RightOutlined /> : <DownOutlined />}
          onClick={(e) => {
            e.stopPropagation();
            onToggleCollapse();
          }}
          className="p-0 h-auto"
          children={undefined}
        />
      )}
    </div>
  );
}
